import React from 'react'

type Props = {
  appIcon: React.ReactNode
  appName: string
  title?: string | null
  subtitle?: string | null
  body: string
  imageUrl?: string | null
  isExpanded: boolean
}

// iOS lock-screen notification (Figma node 34:980): a frosted-dark translucent
// card with white text. Collapsed shows a 32px thumbnail on the right; on
// hover-expand the body is shown in full with the hero image full-bleed below.
const IosPushPreview: React.FC<Props> = ({
  appIcon,
  appName,
  title,
  subtitle,
  body,
  imageUrl,
  isExpanded,
}) => {
  const displayTitle = title || appName

  return (
    <div className="push-ios-notification">
      <div className="push-ios-notification__header">
        <div className="push-ios-notification__icon">{appIcon}</div>
        <div className="push-ios-notification__text">
          <p className="push-ios-notification__title">{displayTitle}</p>
          {subtitle && (
            <p className="push-ios-notification__subtitle">{subtitle}</p>
          )}
          <p
            className={`push-ios-notification__body ${
              !isExpanded ? 'push-ios-notification__body--collapsed' : ''
            }`}
          >
            {body}
          </p>
        </div>
        {!isExpanded && imageUrl && (
          <img
            src={imageUrl}
            alt="notification thumbnail"
            className="push-ios-notification__thumb"
          />
        )}
      </div>
      {isExpanded && imageUrl && (
        <img
          src={imageUrl}
          alt="notification attachment"
          className="push-ios-notification__image"
        />
      )}
    </div>
  )
}

export default IosPushPreview
